<p>registered-bootcamps works!</p>
